

<template>
  <div>
    <div class="container mb-4">
      <title-area title="Foto Galeria"/>
      <div class="row mt-4 g-2">
        <div
          class="col-lg-3 col-md-4 col-sm-6"
          v-for="(src, idx) in pagedImgs"
          :key="idx">
          <img
            :src="src"
            style="width: 100%; height:300px; cursor: pointer; object-fit: cover;"
            @click="showImg((currentPage - 1) * imagesPerPage + idx)"
            class="img-thumbnail"
            alt="Image error!"/>
        </div>
        <VueEasyLightbox
          :visible="visible"
          :imgs="imgs"
          :index="index"
          @hide="handleHide"/>
      </div>
      <!-- Pagination -->
      <nav v-if="totalPages > 1" class="mt-4">
        <ul class="pagination justify-content-center">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="goToPage(currentPage - 1)">‹</button>
          </li>
          <li
            class="page-item"
            v-for="page in visiblePages"
            :key="page"
            :class="{ active: currentPage === page, disabled: page === '...'}">
            <button
              class="page-link"
              v-if="page !== '...'"
              @click="goToPage(page)"
            >{{ page }}</button>
            <span v-else class="page-link">...</span>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="goToPage(currentPage + 1)">›</button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { usePostsStore } from '@/store/PostStore/postStore';
import { computed, ref, onMounted } from 'vue';
import titleArea from '../share/TitleArea.vue';

const postStore = usePostsStore();
const imagesPerPage = 12;
const currentPage = ref(1);

// Modified to split pDetailsFileUrl and take the first image URL
const imgs = computed(() =>
  postStore.leftPosts
    .map(post => post.pDetailsFileUrl ? post.pDetailsFileUrl.split(',')[0] : null)
    .filter(Boolean)
);

// Modified to use the first image URL for paged images
const pagedImgs = computed(() => {
  const start = (currentPage.value - 1) * imagesPerPage;
  return imgs.value.slice(start, start + imagesPerPage);
});

const totalPages = computed(() =>
  Math.ceil(imgs.value.length / imagesPerPage)
);

const visible = ref(false);
const index = ref(0);

function showImg(i) {
  index.value = i;
  visible.value = true;
}

function handleHide() {
  visible.value = false;
}

function goToPage(page) {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
}

// Visible pages logic (max 5 numbers)
const visiblePages = computed(() => {
  const total = totalPages.value;
  const current = currentPage.value;
  const pages = [];
  if (total <= 5) {
    for (let i = 1; i <= total; i++) pages.push(i);
  } else {
    if (current <= 3) {
      pages.push(1, 2, 3, 4, '...', total);
    } else if (current >= total - 2) {
      pages.push(1, '...', total - 3, total - 2, total - 1, total);
    } else {
      pages.push(1, '...', current - 1, current, current + 1, '...', total);
    }
  }
  return pages;
});

onMounted(async () => {
  if (!postStore.leftPosts.length) {
    await postStore.getPostsLeft({
      webPage: '',
      language: 'AL',
      count: 0,
      categoryId: 7,
    });
  }
});
</script>
<style scoped>
.form-control {
  max-width: 300px;
}
.pagination {
  margin-top: 20px;
}
.page-link {
  color: #0b0a21;
  border: 1px solid #dde3eb;
  margin: 0 5px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}
.page-link:hover {
  background-color: #dde3eb;
}
.page-item.active .page-link {
  background-color: #2c3f5e;
  color: white;
  border-color: #2c3f5e;
}
.page-item.disabled .page-link {
  color: #6c757d;
  cursor: not-allowed;
  background-color: #f8f9fa;
  border-color: #dee2e6;
}
tr th:first-child,
tr th:nth-child(3){
  width:150px;
}
tr th:nth-child(4){
  width:100px;
}

</style>